import { createAsyncThunk } from '@reduxjs/toolkit';
import { IApplicationContext } from 'shared/types/applicationContext';
import { fetchSuburbanData } from './fetchSuburbanData';
import { TApplicationState } from '../../types/redux';
import { selectEstimationTarget, selectSuburbanFormValues } from '../../selectors/filters';
import { mapEstimationTargetToECategory } from './mappers';
import { EEstimationTargets, validateFilters } from '@cian/valuation-main-filters-widget';
import { selectSource } from 'shared/selectors/page';

export const submitSuburbanData = createAsyncThunk('form/submitSuburbanData', async (_, _thunkApi) => {
  const { extra, rejectWithValue, getState, dispatch } = _thunkApi;

  const isFormValid = await dispatch(validateFilters());

  if (!isFormValid) {
    return;
  }

  const state = getState() as TApplicationState;

  const { address, landArea, houseArea } = selectSuburbanFormValues(state);
  const estimationTarget = selectEstimationTarget(state);
  const source = selectSource(state);

  if (estimationTarget === EEstimationTargets.house && (!address || !landArea || !houseArea)) {
    return;
  }

  if (estimationTarget === EEstimationTargets.land && (!address || !landArea)) {
    return;
  }

  const parameters = {
    address,
    landArea: landArea as number,
    houseArea,
    category: mapEstimationTargetToECategory[estimationTarget],
    isNeedPushSubscribe: false,
    source,
  };

  try {
    const res = await fetchSuburbanData(parameters, extra as IApplicationContext);

    return res;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
